import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getChatList } from "@/api/chat";
import { getGameServerMap } from "@/utils/dictionary";
import timeDateOptions from "../../components/timeList/timeDateOptions.vue";
import serverList from "../../components/serverList/serverOptions.vue";
import infoList from "@/mixins/infoList";
import { commonConfig } from "@/api/config";
import BanRoleLogin from "./components/banRoleLogin.vue";
import BanRoleChat from "./components/banRoleChat.vue";
import BanOpenid from "./components/banOpenid.vue";
export default {
  name: "chatSearch",
  components: {
    timeDateOptions: timeDateOptions,
    serverList: serverList,
    BanRoleLogin: BanRoleLogin,
    BanRoleChat: BanRoleChat,
    BanOpenid: BanOpenid
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getChatList,
      sel_chatTime: false,
      timedata: [this.$moment().subtract(1, "days").format("YYYY-MM-DD 00:00:00"), this.$moment().format("YYYY-MM-DD 23:59:59")],
      sdata: "",
      edata: "",
      seerver_list: "",
      chat_content: "",
      openID_value: "",
      roleID_value: "",
      roleName_value: "",
      searchInfo: {
        server_id: []
      },
      channelConfig: {
        1: "私聊",
        2: "公会频道",
        3: "队伍频道",
        4: "世界聊天"
      },
      chatChannel: [],
      banLoginForm: {},
      banChatForm: {},
      banOpenIdForm: {},
      banRoleLoginDialog: false,
      banRoleChatDialog: false,
      banOpenIdDialog: false
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      commonConfig({
        index: "chat_channel"
      }).then(function (res) {
        _this.chatChannel = res.data;
      });
      getGameServerMap().then(function (res) {
        console.log(_this.server_list);
        _this.server_list = res;
      });
    },
    cellStyle: function cellStyle(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      console.log(row);
      console.log(column);
      console.log(rowIndex);
      //第n(6)列的时候，才改变
      if (columnIndex === 4) {
        return "colStyle";
      } else {
        return "notcolStyle";
      }
    },
    openBox: function openBox() {
      this.$notify({
        title: "聊天查询【未对接接口】",
        message: "（1）可根据筛选的服务器列表，查看服务器的聊天记录。" + "(2) 提供账号Id、角色Id、角色名、时间范围查询聊天记录。" + "(3)提供聊天内容关键词查询",
        duration: 0
      });
    },
    queryEvent: function queryEvent() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.searchInfo.sdate = _this2.timedata[0];
              _this2.searchInfo.edate = _this2.timedata[1];
              _context.next = 4;
              return _this2.getTableData(1);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    banRoleLogin: function banRoleLogin(server_id, role_id) {
      this.banLoginForm.serverId = server_id;
      this.banLoginForm.roleId = role_id;
      this.banRoleLoginDialog = true;
    },
    banLoginFinish: function banLoginFinish() {
      this.banRoleLoginDialog = false;
      this.getTableData();
    },
    banRoleChat: function banRoleChat(server_id, role_id) {
      this.banChatForm.serverId = server_id;
      this.banChatForm.roleId = role_id;
      this.banRoleChatDialog = true;
    },
    banChatFinish: function banChatFinish() {
      this.banRoleChatDialog = false;
      this.getTableData();
    },
    banOpenId: function banOpenId(open_id) {
      this.banOpenIdForm.openId = open_id;
      this.banOpenIdDialog = true;
    },
    banOpenIdFinish: function banOpenIdFinish() {
      this.banOpenIdDialog = false;
      this.getTableData();
    }
  }
};